import {addOverlay, removeOverlay} from "../../library/overlay";
import {get} from "../../website/webpack/modules/ajax";
import Swiper from "swiper/js/swiper";

var swiperInstances = [];

$(document).ready(function() {
    $(window).resize(function() {
        for (var slider of swiperInstances) {
            slider.update();
        }
    });
    $('.open-product-reviews').click(function() {
        addOverlay();
        $('#review-right-full-container').addClass('open');
        initSliders();

        $('#review-right-close').delay(400).show(0);
    });

    $(document).on('click', '#review-right-full-close, .overlay', function() {
        let review = $("#review-right-full-container");
        if (review && review.hasClass('open')) {
            closeReviews();
        }
    });

    $(document).on('click', '#load-more-product-reviews', function() {
        if (typeof getPopupAjax === 'object') {
            return;
        }
        let productId = $(this).data('id');
        let button = $(this);
        let page = parseInt(button.data('page')) + 1;

        let url = '/ajax/website/get-product-reviews-canvas/'+productId;
        if (page > 1) url += '/'+page;
        var getPopupAjax;

        getPopupAjax = $.get(
            url,
            {'version': 'web'},
            function(data) {
                $('.reviews-list').append(data.list);
                button.data('page', page);
                if (page ===  data.lastPage) {
                    button.css('display','none');
                }

                initSliders();
                getPopupAjax = undefined;
            }
        ).always(function() {
        });
    });
});

function getReviews(productId, page)
{
    return new Promise(resolve => {
        let url = '/ajax/website/get-product-reviews-canvas/'+productId;
        if (page > 1) url += '/'+page;
        get(url, {'version': 'web'}, (response) => resolve(response));
    });
}

function closeReviews() {
    removeOverlay();
    $('#review-right-full-container').removeClass('open');
}

function initSliders(container) {
    container = container || $('#review-right-full-container');

    //INIT SLIDERS PRODUCT LIST
    let index = swiperInstances.length;
    container.find(".review .swiper-container").each(function(){ //some-slider-wrap-in
        var $this = $(this);
        $this.addClass("instance-" + index); //instance need to be unique (ex: some-slider)
        $this.parent().find(".swiper-button-prev").addClass("prev-" + index); //prev must be unique (ex: some-slider-prev)
        $this.parent().find(".swiper-button-next").addClass("next-" + index); //next must be unique (ex: some-slider-next)
        swiperInstances[index] = new Swiper(".instance-" + index, { //instance need to be unique (ex: some-slider)
            loop: false,
            slidesPerView: 'auto',
            slidesPerGroupAuto: true,
            spaceBetween: 10,
            preloadImages: false,
            lazy: {
                loadOnTransitionStart: true,
            },
            watchOverflow: true,
            navigation: {
                prevEl: ".prev-" + index,  //prev must be unique (ex: some-slider-prev)
                nextEl: ".next-" + index, //next must be unique (ex: some-slider-next)
            },
        });

        index++;
    });

    // Now you can call the update on a specific instance in the "swiperInstances" object
    setTimeout(function () {
        for (var slider of swiperInstances) {
            slider.update();
            slider.slides.each(function(){
                $(this).find('img.lazy').unveil().removeClass('lazy');
            });
        }
    }, 50);
}
